// extracted by mini-css-extract-plugin
export default {"wrapperClass":"lWo9lTZGDLfpnj41D9Ma"};